module.exports = __webpack_public_path__ + "img/10.64933f82.jpg";